import { App, WidgetOperationTypes } from '@openedx/frontend-base';

import { DesktopHeaderLanguage } from './thervumitra/HeaderLanguage';
import { HeaderShop } from './thervumitra/commerce/HeaderShop';
import HeaderNav from './HeaderNav';
import { InstructorCourseBanner } from './CourseLayout';
import MobileHeader from './MobileHeader';
import ThervuMitraFooter from './ThervuMitraFooter';
import QueryDefaults from './QueryDefaults';

// Site-wide customisations for ThervuMitra: the learner dashboard's header
// (Courses, Discover new, Vidya AI and search: HeaderNav.tsx; notifications,
// wishlist and cart, language, account; on phones its menu-button layout with
// the search below: MobileHeader.tsx), the learning MFE's course banner in
// place of the course tab bar and no masquerade bar (the course menu is on the
// page: CourseLayout.tsx), and the ThervuMitra footer in place of
// frontend-base's default footer layout. The desktop header keeps
// frontend-base's layout with the ThervuMitra logo and styles
// (site.config.build.tsx, public/index.html). More: addSlot(customApp, ...) / addScript(customApp, ...) from ./utils.
const customApp: App = {
  appId: 'custom',
  slots: [
    {
      slotId: 'org.openedx.frontend.slot.header.desktopLeft.v1',
      id: 'thervumitra.widget.header.queryDefaults',
      op: WidgetOperationTypes.PREPEND,
      component: QueryDefaults,
    },
    // Right side in the learner dashboard's order: notifications, wishlist and
    // cart, language, account.
    {
      slotId: 'org.openedx.frontend.slot.header.desktopRight.v1',
      id: 'thervumitra.widget.header.shop',
      relatedId: 'org.openedx.frontend.widget.header.desktopAuthenticatedMenu.v1',
      op: WidgetOperationTypes.INSERT_BEFORE,
      component: HeaderShop,
      condition: { authenticated: true },
    },
    {
      slotId: 'org.openedx.frontend.slot.header.desktopRight.v1',
      id: 'thervumitra.widget.header.desktopLanguage',
      relatedId: 'org.openedx.frontend.widget.header.desktopAuthenticatedMenu.v1',
      op: WidgetOperationTypes.INSERT_BEFORE,
      component: DesktopHeaderLanguage,
    },
    {
      slotId: 'org.openedx.frontend.slot.header.primaryLinks.v1',
      relatedId: 'org.openedx.frontend.widget.slotShowcase.headerLink',
      op: WidgetOperationTypes.REMOVE,
    },
    {
      slotId: 'org.openedx.frontend.slot.header.primaryLinks.v1',
      id: 'thervumitra.widget.header.learningNav',
      op: WidgetOperationTypes.APPEND,
      component: HeaderNav,
    },
    {
      slotId: 'org.openedx.frontend.slot.header.masqueradeBar.v1',
      relatedId: 'org.openedx.frontend.widget.header.masqueradeBar.v1',
      op: WidgetOperationTypes.REMOVE,
    },
    {
      slotId: 'org.openedx.frontend.slot.header.courseNavigationBar.v1',
      id: 'thervumitra.widget.header.courseBanner',
      relatedId: 'org.openedx.frontend.widget.header.courseNavigationBar.v1',
      op: WidgetOperationTypes.REPLACE,
      component: InstructorCourseBanner,
    },
    {
      slotId: 'org.openedx.frontend.slot.header.mobile.v1',
      id: 'thervumitra.widget.header.mobileLayout',
      relatedId: 'org.openedx.frontend.widget.header.mobileLayout.v1',
      op: WidgetOperationTypes.REPLACE,
      component: MobileHeader,
    },
    {
      slotId: 'org.openedx.frontend.slot.footer.desktop.v1',
      id: 'thervumitra.widget.footer',
      relatedId: 'org.openedx.frontend.widget.footer.desktopLayout.v1',
      op: WidgetOperationTypes.REPLACE,
      component: ThervuMitraFooter,
    },
  ],
};

export default customApp;
